<div class="background">
  <div class="container surface-card shadow-3 border-round">
    <div class="logo-container">
      <img alt="Image" class="image" height="200" src="assets/godh_logo_transparency.png">
    </div>
    <div class="separator-container">
      <div class="separator"></div>
    </div>
    <div class="p-4 w-full">
      <div class="text-center mb-5">
        <div class="text-900 text-3xl font-medium mb-3">Forgot Password?</div>
        <span class="text-600 font-medium line-height-3">No worries! We'll send you a link to reset it.</span>
      </div>

      <div>
        <label class="block text-900 font-medium mb-2" for="email1">Email</label>
        <input [(ngModel)]="email" class="w-full" id="email1" pInputText type="text" (keyup.enter)="sendEmail()"
               [problem-details]="problemDetails" problemDetailsKey="email">

        <div class="flex align-items-center justify-content-between mb-6">
          <a class="font-medium no-underline ml-2 text-yellow-600 text-right cursor-pointer" (click)="changeStateToLogin()"
             queryParamsHandling="preserve" routerLink="/login">I know my password! Log in</a>
        </div>

        <button (click)="sendEmail()" class="w-full">Send Reset Link</button>
      </div>
    </div>

  </div>
</div>
